"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GroupingValues = void 0;
var GroupingValues;
exports.GroupingValues = GroupingValues;

(function (GroupingValues) {
  GroupingValues["GROUPS_TOP_PARENT"] = "groupsTopParent";
  GroupingValues["GROUPS_CHILDREN"] = "groupsChildren";
  GroupingValues["ALL_GROUPS_CHILDREN"] = "allGroupsChildren";
  GroupingValues["USERS"] = "users";
  GroupingValues["ALL_USERS"] = "allUsers";
})(GroupingValues || (exports.GroupingValues = GroupingValues = {}));

var calculationMethodRestrictionsFromGrouping = {
  users: ['total'],
  allUsers: ['total'],
  groupsChildren: ['total', 'PerMembersCount'],
  groupsTopParent: ['total', 'PerMembersCount'],
  allGroupsChildren: ['total', 'PerMembersCount']
};
var sortRestrictionsFromSport = {
  All: ['points', 'duration', 'activitiesCount'],
  Running: ['points', 'duration', 'distance', 'activitiesCount', 'climb'],
  Cycling: ['points', 'duration', 'distance', 'activitiesCount', 'climb'],
  Swimming: ['points', 'duration', 'distance', 'activitiesCount'],
  Walking: ['points', 'steps'],
  Treadmill: ['points', 'duration', 'distance', 'activitiesCount'],
  IndoorCycling: ['points', 'duration', 'distance', 'activitiesCount'],
  Hiking: ['points', 'duration', 'distance', 'climb', 'activitiesCount'],
  OutdoorWalking: ['points', 'duration', 'distance', 'climb', 'activitiesCount'],
  dailyCategory: ['points', 'steps'],
  runningCategory: ['points', 'duration', 'distance', 'activitiesCount'],
  cyclingCategory: ['points', 'duration', 'distance', 'activitiesCount'],
  swimmingCategory: ['points', 'duration', 'distance', 'activitiesCount'],
  walkingCategory: ['points', 'duration', 'distance', 'activitiesCount']
};
var _default = {
  calculationMethodRestrictionsFromGrouping: calculationMethodRestrictionsFromGrouping,
  sortRestrictionsFromSport: sortRestrictionsFromSport
};
exports["default"] = _default;
//# sourceMappingURL=constants.js.map